import React, { useEffect } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from 'react-router-dom';

const PendingPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="text-center">
        <div style={{ fontSize: "4rem" }}>😐</div>
        <h1 className="text-warning">Payment Pending</h1>
        <p>
            We've received your request. If you selected cash or EFT, please use the reference
            provided to complete payment.
        </p>
        <small>You will be redirected to the homepage shortly...</small>
        </div>
    </div>
  );
};

export default PendingPage;
